import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../../_metronic/_helpers";
import { StatusColumnFormatter } from "../../topup-table/column-formatters/StatusColumnFormatter";

const InvoiceTable = ({ invoiceItem = [], topUpInvoice = {} }) => {
  // Table columns
  const columns = [
    {
      dataField: "item",
      headerClasses: "text-center",
      text: "Item",
      classes: "text-center",
      footer: "Total Biaya Tambahan:",
      footerClasses: "text-center",
      formatter: (cell) => {
        let render = "";
        switch (cell) {
          case "DONOR":
            render = "BIAYA TAMBAHAN DONATUR";
            break;
          case "USER":
            render = "BIAYA TAMBAHAN USER";
            break;
          case "PREV_INVOICE":
            render = "TAGIHAN BULAN LALU";
            break;

          default:
            render = cell;
            break;
        }
        return <span>{render}</span>;
      },
    },
    {
      dataField: "price",
      headerClasses: "text-right",
      text: "Harga per Item",
      classes: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
      footer: "",
      footerClasses: "text-center",
    },
    {
      dataField: "qty",
      headerClasses: "text-center",
      text: "Jumlah",
      classes: "text-center",
      footer: (cell) => {
        return cell.reduce((prev, curr) => prev + curr, 0);
      },
      footerClasses: "text-center",
    },
    {
      dataField: "total_price",
      text: "Jumlah",
      headerClasses: "text-right",
      classes: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
      footer: (cell) => {
        const sum = cell.reduce((prev, curr) => prev + curr, 0);
        return currencyFormatter(sum);
      },
      footerClasses: "text-right",
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col row">
          <div className="col-lg-3">
            <b>Invoice ID</b>
          </div>
          <div className="col-lg-1">:</div>
          <div className="col-lg-7">
            <b>{topUpInvoice.invoice_hid}</b>
          </div>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col row">
          <div className="col-lg-3">
            <b>Paket Pembelian</b>
          </div>
          <div className="col-lg-1">:</div>
          <div className="col-lg-7">
            <b>{topUpInvoice.plan && topUpInvoice.plan.name}</b>
          </div>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col row">
          <div className="col-lg-3">
            <b>Harga Paket</b>
          </div>
          <div className="col-lg-1">:</div>
          <div className="col-lg-7">
            <b>
              {currencyFormatter(topUpInvoice.plan && topUpInvoice.plan.price)}
            </b>
          </div>
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col row">
          <div className="col-lg-3">
            <b>Status</b>
          </div>
          <div className="col-lg-1">:</div>
          <div className="col-lg-7">
            {StatusColumnFormatter(topUpInvoice.status)}
          </div>
        </div>
      </div>
      <br />

      <BootstrapTable
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        striped
        bordered={false}
        remote
        keyField="uuid"
        data={invoiceItem === null ? [] : invoiceItem}
        columns={columns}
      >
        <PleaseWaitMessage entities={invoiceItem} />
        <NoRecordsFoundMessage entities={invoiceItem} />
      </BootstrapTable>

      {/* Style 1 */}
      {/* <div>
        <h3 className="float-right mt-8">
          <b>
            Total Pembayaran: {currencyFormatter(topUpInvoice.invoice_price)}
          </b>
        </h3>
      </div> */}

      {/* Style 2 */}
      <div className="form-group row">
        <div className="col-lg-9 text-right mt-2">
          <h4>Pajak Pembayaran: </h4>
        </div>
        <div className="col-lg-3">
          <input
            className="form-control text-right font-weight-bold"
            disabled
            value={currencyFormatter(topUpInvoice.invoice_tax)}
            label="Nominal"
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-lg-9 text-right mt-2">
          <h4>Total Pembayaran: </h4>
        </div>
        <div className="col-lg-3">
          <input
            className="form-control text-right font-weight-bold"
            disabled
            value={currencyFormatter(topUpInvoice.invoice_grand_total)}
            label="Nominal"
          />
        </div>
      </div>
    </>
  );
};

export default InvoiceTable;
